import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './Avatar.pcss';
import Message from '../message/Message';
import Pip from '../pip/Pip';

import {CustomPropTypes, CustomPropShapes, presenceTypes, sizes, shapes} from '../../constants';

/** This component renders the user avatar with a fallback using the first letter of the username when the picture doesn't exist */
class Avatar extends PureComponent {
    static displayName = 'Avatar';
    static propTypes = {
        /** the image url */
        avatar: PropTypes.string,
        /** the hex color used in the container when the image doesn't exist */
        backgroundColor: CustomPropTypes.color,
        className: PropTypes.string,
        /** the username where the first letter is taken */
        displayName: PropTypes.string,
        /** the hex color of the letter */
        initialColor: PropTypes.string,
        presence: CustomPropShapes.oneOfConstant(presenceTypes),
        /** one of the sizes from common constants */
        size: CustomPropShapes.oneOfConstant(sizes),
        /** one of the shapes from common constants */
        type: CustomPropShapes.oneOfConstant(shapes)
    };

    static defaultProps = {
        size: sizes.MEDIUM,
        type: shapes.ROUND,
        displayName: ''
    };

    render() {
        const {
            avatar,
            backgroundColor,
            className,
            displayName,
            initialColor,
            presence,
            size,
            type
        } = this.props;

        const avatarClasses = cx(className, styles.avatar, styles[size], styles[type]);
        const initial = (displayName && displayName.match(/[a-zA-Z]{1}/g)) || '';
        return (
            <span className={styles.wrapper}>
                {presence && <Pip className={styles.pip} presence={presence} />}
                <span className={avatarClasses}>
                    {avatar ? (
                        <img src={avatar} alt={displayName} />
                    ) : (
                        <span
                            className={styles.initial}
                            style={{color: initialColor, backgroundColor}}>
                            {initial ? (
                                initial[0]
                            ) : (
                                <Message code="diesel.common.avatar.placeholder_avatar_character" />
                            )}
                        </span>
                    )}
                </span>
            </span>
        );
    }
}

export default Avatar;
